<template>
  <main id="app" v-if="eligible">
    <StartButton
     v-if="!chatMinimized"
     @click="handleStartChat"
     :class="{offhours:!isChatEnable}"
     @mouseenter="showModelComponentOffline"
     @mouseleave="hideModelComponentOffline"
    />
    <ModelComponentOffline
      v-if="showChatOfllineModal"
      @mouseenter="showModelComponentOffline"
      @mouseleave="hideModelComponentOffline"
      :fsAgentAvailableData="fsAgentAvailableData"/>
      <Transition name="slide">
<!--        Main file for widget logic-->
        <Main
          class="main-container"
          ref="mainContainer"
          :class="{ expanded: chatExpanded }"
          :prechatList="prechatList"
          :privacyDisclaimer="privacyDisclaimer"
          :toasterConfigData='toasterConfigData'
          :liveChatPage='liveChatPage'
          :userDetails="userDetails"
          :IVRAgents="IVRAgents"
          :nonIVRAgents="nonIVRAgents"
          v-if="showChatWindow === 'show' || chatStarted"
          @closeChat="handleCloseChat"
          @resizeChat="handleChatResize"
          @recheckEligibility="checkEligibility"
          @setShowChat="setShowChat"
          @startChat="startChat"
          @toasterBrowserSession="toasterBrowserSession"
          @enableMedallia="enableMedallia"
        />
      </Transition>
  </main>
</template>
<script>
import Main from '@/views/Main.vue'
import StartButton from '@/components/common/StartButton.vue'
import translations from '@/translations/translations.json'
import { getEligibility, getAgentAvailability, getAgentAvailabilityV2, getAgentInformation, getAgentAvailabilityfs, getUserDetails } from '@/services/api'
import { mapState, mapActions } from 'pinia'
import { useWidgetStore } from '@/store'
import { chatOpenTracking } from '@/utils/analytics'
import { uiToggleConfigs } from '@/utils/constants'
import ModelComponentOffline from './components/common/ModelComponentOffline.vue'

export default {
  name: 'App',
  data () {
    return {
      eligible: false,
      headerHeight: 0,
      translations,
      componentKey: 0,
      eligiblePage: false,
      prechatList: [],
      privacyDisclaimer: false,
      chatExpanded: false,
      renderComponent: true,
      showChatWindow: 'hide',
      toasterConfigData: [],
      toastereligible: false,
      contactPageToaster: false,
      params: {},
      liveChatPage: false,
      nonIVRAgents: [],
      IVRAgents: [],
      agentAvailabilityInterval: null,
      expireTimeToaster: '',
      fsAgentAvailableData: [],
      showChatOfllineModal: false,
      isChatEnable: true,
      agentAvailabilityIntervalFs: null,
      hoverModalTimeout: null,
      userDetails: {}
    }
  },
  mounted () {
  // Add custom event listener to hide chat widget from the outside components
  // call every 30 sec this method for fsagentAvailable based on livechatfs
    this.agentAvailabilityIntervalFs = setInterval(this.agentAvailabilityFS, 30000)
    window.hideChatWidget = new Event('hideChatWidget')
    this.setGlobalVaribles()
    document.addEventListener(
      'hideChatWidget', (event) => {
        try {
          if (!this.chatStarted) {
            this.eligible = false
          }
        } catch (error) {
          console.log('Error while hiding chat widget', error)
        }
      }
    )

    // Add custom event listener to show chat widget from the outside components
    window.showChatWidget = new Event('showChatWidget')
    document.addEventListener(
      'showChatWidget', (event) => {
        try {
          this.eligible = true
        } catch (error) {
          console.log('Error while showing chat widget', error)
        }
      }
    )

    console.log('mounted chat widget from new cluster v2')
    /** request to eligibility on each initialize of the widget
     * browserLang
     * countryCode
     * sent with eligibility request
     * **/
    const browserLang = this.getCookie?.('CK_LANG_CODE') || this.getCookie?.('locale')?.split('_')[0] || localStorage.getItem?.('chatLanguageCode') || window.navigator.language?.split('-')[0]
    const country = this.getCookie?.('CK_ISO_CODE') || this.getCookie?.('locale')?.split('_')[1].toLowerCase() || localStorage.getItem?.('chatCountryCode') || window.navigator.language?.split('-')[1]?.toLowerCase()
    this.expireTimeToaster = this.getCookie?.('toaster_browserSession')
    localStorage.setItem('lang', browserLang)
    localStorage.setItem('country_code', country)
    this.$i18n.locale = browserLang
    this.params = {
      countryCode: country,
      languageCode: browserLang
    }
    this.setDarkProdFlag(this.getCookie?.('darkChatGatewayProd') === 'true' && this.isFishersci && process.env.VUE_APP_DARK_MODE === 'true')
    if (this.params.countryCode === undefined || this.params.countryCode === null || this.params.countryCode === '' || this.params.languageCode === undefined || this.params.languageCode === null || this.params.languageCode === '') {
      console.error('Country code or language code not found')
      return
    }
    const self = this
    // Clearing the prechat form data from local storage to make sure nothing will go wrong as a part of chat-requested event
    this.setPreChatFormData([])

    this.checkEligibility()
    // this api call only cantact-us page
    if (window.location.pathname.includes('technical-resources/contact-us')) {
      this.toasterContactPageEligibility()
    }
    // Listen AJAX request
    // Needs to know the user click which subsection by checking subsection selected style,
    const open = window.XMLHttpRequest.prototype.open
    window.XMLHttpRequest.prototype.open = function (method, url, async, user, password) {
      if (self.sessionId === undefined || self.sessionId == null || self.sessionId === 'null') {
        onReadyAfterMessengerInitial(url)
      }
      return open.apply(this, arguments)
    }
    function onReadyAfterMessengerInitial (url) {
    // console.log('Listen AJAX request',url);
      const contactUsSelfServiceUrlRegex = /^\S*us\/en\/home\/technical-resources\/contact-us\/self-service\/\S*\.html\?\S*$/
      const contactUsSupportTypesUrlRegex = /^\S*us\/en\/home\/technical-resources\/contact-us\/support-types\/\S*\.html\?contactType=ContactUs&supportType=\w*&deepLink=\S*$/
      const contactUsEligibleUrl = ['/home/technical-resources/contact-us/support-types/customer-service.html?contactType=ContactUs&supportType=SL&deepLink=SL&wcmmode=disabled', '/home/technical-resources/contact-us/support-types/online-order-support-st.html?contactType=ContactUs&supportType=OS&deepLink=OS&wcmmode=disabled']
      if ((contactUsSelfServiceUrlRegex.test(url) || contactUsSupportTypesUrlRegex.test(url))) {
        let eligibleFlag = false
        for (let i = 0; i < contactUsEligibleUrl.length; i++) {
          if (url.indexOf(contactUsEligibleUrl[i]) > -1) {
            eligibleFlag = true
            break
          } else {
            eligibleFlag = false
          }
        }
        if (eligibleFlag) {
          self.eligible = false
          self.showChatWindow = 'hide'
          self.$nextTick(() => {
            // Add the widget back in
            self.eligible = true
            self.contactPageToaster = true
            // self.showChatWindow = 'show';
          })
        } else {
          self.eligible = eligibleFlag
          self.contactPageToaster = false
        }
      }
    }

    // Add custom event listener to show prechat form from the outside components
    window.showChatWidgetForm = new Event('showPrechatForm')
    document.addEventListener(
      'showPrechatForm', (event) => {
        try {
          this.startChat()
        } catch (error) {
          console.log('Error while showing prechat form', error)
        }
      }
    )
  },
  beforeUnmount () {
    if (this.agentAvailabilityInterval) {
      clearInterval(this.agentAvailabilityInterval)
    }
    if (this.agentAvailabilityIntervalFs) {
      clearInterval(this.agentAvailabilityIntervalFs)
    }
  },
  updated () {
    if (this.contactPageToaster) {
      this.toasterContactPageEligibility()
    }
    if (this.toastereligible && !this.expireTimeToaster) {
      // Check the toaster cookie value
      this.expireTimeToaster = this.getCookie?.('toaster_browserSession')
    }

    if (this.showChatWindow === 'hide' && this.toastereligible && !this.expireTimeToaster) {
      this.showToasster()
    }
  },
  components: {
    Main,
    StartButton,
    ModelComponentOffline
  },
  computed: {
    ...mapState(useWidgetStore, ['eligibleChat', 'chatExpanded', 'messageHistory', 'prechatFormData', 'prechatDisclaimerMessage', 'showPrechatForm', 'isFishersci', 'sessionId', 'chatStarted', 'chatMinimized', 'loggedInUserFormData', 'supportAnchorLinkFS', 'darkProdFlag'])
  },
  methods: {
    ...mapActions(useWidgetStore, ['setEligibleChat', 'setPreChatFormData', 'setPrechatDisclaimerMessage', 'setLoggedInUserFormData', 'setSupportAnchorLinkFSData', 'setDarkProdFlag']),
    // this is for fs ca region handle chat click
    handleStartChat () {
      if (this.isChatEnable) {
        this.startChat()
      }
    },
    startChat () {
      this.setDarkProdFlag(this.getCookie?.('darkChatGatewayProd') === 'true' && this.isFishersci && process.env.VUE_APP_DARK_MODE === 'true')
      /* Chat open tracking */
      chatOpenTracking()

      // Add class to body element when chat is started
      document.querySelector('body').classList.add('active-gatewayChat')

      this.showChatWindow = 'show'
      if (this.showPrechatForm && this.prechatList?.length > 0) {
        this.$nextTick(() => {
          this.$refs.mainContainer.proccedToPrechat()
        })
      } else if (!this.isFishersci) {
        this.$nextTick(() => {
          this.$refs.mainContainer.startInitiateChat()
        })
      }
    },
    setGlobalVaribles () {
      window.digitalData = window.digitalData || {}
      window.digitalData.widgets = window.digitalData.widgets || {}
      window.digitalData.widgets.chat = window.digitalData.widgets.chat || {}
      window.digitalData.widgets.chat.customer = window.digitalData.widgets.chat.customer || {}
      window.digitalData.widgets.chat.agent = window.digitalData.widgets.chat.agent || {}
    },
    enableMedallia (medalliasessionId) {
      const key = medalliasessionId
      if (key) {
        // 1. Get the agent information from Redis cache by chatSessionId or uniqueChatId
        getAgentInformation(key).then((res) => {
          const obj = res.data
          // 2. Identify the agent type is in the medalliaAgentTopic list or not
          if (obj?.data?.medaliaSurveyEnabled === true) {
            this.populateAgentInfoToMadelliaDataLayer(obj.data, key)
            // 4. and trigger Medallia rules
            this.triggerMedalliaRule()
          }
        })
      }
    },
    agentAvailabilityFS () {
      if (this.fsAgentAvailableData?.agentAvailable === false) {
        this.getAgentStatusfs()
      }
    },
    populateAgentInfoToMadelliaDataLayer (AgentInformation, key) {
      if (AgentInformation?.firstName) {
        window.digitalData.widgets.chat.agent.firstName = AgentInformation?.firstName
      }
      if (AgentInformation?.AgentLastName) {
        window.digitalData.widgets.chat.agent.lastName = AgentInformation?.AgentLastName
      }
      if (AgentInformation?.userId) {
        window.digitalData.widgets.chat.agent.employeeId = AgentInformation?.userId
      }
      window.digitalData.widgets.chat.endChat = true
      window.digitalData.widgets.chat.eventType = AgentInformation?.medaliaSurveyProperties?.eventType
      window.digitalData.widgets.chat.agent.siteId = AgentInformation?.medaliaSurveyProperties?.siteId
      window.digitalData.widgets.chat.agent.siteName = AgentInformation?.medaliaSurveyProperties?.siteName
      window.digitalData.widgets.chat.brand = AgentInformation?.medaliaSurveyProperties?.brand
      window.digitalData.widgets.chat.inviteLanguage = AgentInformation?.medaliaSurveyProperties?.inviteLanguage
      window.digitalData.widgets.chat.surveyLanguage = AgentInformation?.medaliaSurveyProperties?.surveyLanguage
      window.digitalData.widgets.chat.surveyFormName = AgentInformation?.medaliaSurveyProperties?.surveyName
      window.digitalData.widgets.chat.chatSessionId = key
      window.digitalData.widgets.chat.channel = AgentInformation?.medaliaSurveyProperties?.channel
      window.digitalData.widgets.chat.bu = AgentInformation?.medaliaSurveyProperties?.bu
      window.digitalData.widgets.chat.division = AgentInformation?.medaliaSurveyProperties?.division
    },
    triggerMedalliaRule () {
      if (window.KAMPYLE_ONSITE_SDK && typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function') {
        window.KAMPYLE_ONSITE_SDK.updatePageView()
      }
    },
    // for eligibility api call for contat-us page for toaster
    toasterContactPageEligibility () {
      getEligibility(this.params).then((res) => {
        this.toasterConfigData = res.data.toasterConfig
        this.toastereligible = this.toasterConfigData?.isEnable
      }).catch(() => {
        console.log('err')
      })
    },
    showModelComponentOffline () {
      if (!this.isChatEnable) {
        clearTimeout(this.hoverModalTimeout)
        this.showChatOfllineModal = true
      }
    },
    hideModelComponentOffline () {
      if (!this.isChatEnable) {
        this.hoverModalTimeout = setTimeout(() => {
          this.showChatOfllineModal = false
        }, 100)
      }
    },
    showToasster () {
      setTimeout(() => {
        this.setShowChat('show')
      }, this.toasterConfigData?.autoInvite)
    },
    // this method is used for toaster popup handle the duration of the browser session
    toasterBrowserSession () {
      if (!this.expireTimeToaster && this.toasterConfigData.isBrowserSession) {
        const now = new Date()
        const expireTime = new Date(now.getTime() + 48 * 60 * 60 * 1000) // 48hour from now
        console.log('Cookie will expire on:', expireTime.toLocaleString()) // add log for debugging
        document.cookie = 'toaster_browserSession=firstVisit;path=/;expires=' + expireTime.toUTCString() + ';'
      }
    },
    handleCloseChat () {
      this.showChatWindow = 'hide'
      this.chatExpanded = false
      this.eligible = false
    },
    handleChatResize (value) {
      // Calculate header height to avoid header collapsing
      if (value && document.getElementsByTagName('header')[0]?.offsetHeight) {
        this.headerHeight = document.getElementsByTagName('header')[0].offsetHeight + 'px'
      }
      this.chatExpanded = value
    },
    checkEligibility (isTerminated) {
      console.log('Calling eligibility from the new cluster')
      if (window.location.pathname.includes('technical-resources/contact-us') && (this.sessionId === undefined || this.sessionId == null || this.sessionId === 'null')) {
        this.eligible = false
        this.setEligibleChat(false)
        return
      } if (!this.chatStarted || isTerminated) {
        getEligibility(this.params).then((res) => {
          // this.eligible = res.data.eligible
          // this.setEligibleChat(this.eligible)
          if (res.data.eligible) {
            this.prechatList = res.data.prechatList
            this.privacyDisclaimer = res.data.privacyDisclaimer
            this.setPreChatFormData(res.data.prechatList)
            this.setPrechatDisclaimerMessage(res.data.privacyDisclaimer)
            this.toasterConfigData = res.data.toasterConfig
            this.toastereligible = this.toasterConfigData?.isEnable

            if (res?.data?.helpNsupportLink) {
              this.setSupportAnchorLinkFSData(res?.data?.helpNsupportLink)
            }
            // Allow chat on GSS pages only if gssPage is true
            if (res?.data?.chatFeatures?.gssPage) {
              return
            }
            // Allow chat on Bid Sales pages only if bidSalesPage is true
            if (res?.data?.chatFeatures?.bidSalesPage && (!this.getCookie('bidSalesPage') || this.getCookie('bidSalesPage') !== 'true')) {
              return
            }
            if (!this.isFishersci && uiToggleConfigs?.enableLoggedInUser) {
              getUserDetails().then((res) => {
                this.userDetails = res?.data
                this.setLoggedInUserFormData(res?.data)
              })
            }

            if (res?.data?.livechatfs) {
              getAgentAvailabilityfs(this.params).then((res) => {
                this.fsAgentAvailableData = res?.data
                this.isChatEnable = res?.data?.agentAvailable
              })
            }

            this.nonIVRAgents = res?.data?.eligibleNonIVRAgents || []
            this.IVRAgents = res?.data?.eligibleIVRAgents || []

            if (res?.data?.livechat) {
              this.liveChatPage = true
                if (this.IVRAgents.length === 0) {
                  if (this.checkAgentEligibility()) {
                    if (res?.data?.tfAgentAvailV2Enabled) {
                      this.getAgentStatusV2()
                    } else {
                      this.getAgentStatus()
                    }
                  } else {
                    this.eligible = false
                  }
                } else {
                  this.eligible = true
                  this.setEligibleChat(this.eligible)
                }
            } else {
              this.eligible = res.data.eligible
              this.setEligibleChat(this.eligible)
            }
          } else {
            this.eligible = false
          }

          // this.checkOpenArrayPageEligibility();
        }).catch(() => {
          this.eligible = false
        })
      } else {
        this.eligible = true
        // Fetch prechatForm data during page refresh
        this.prechatList = this.prechatFormData
        this.privacyDisclaimer = this.prechatDisclaimerMessage
        this.userDetails = this.loggedInUserFormData
      }

      if (window.location.pathname.includes('order/taqman-files')) {
        const that = this
        // Adding onchange listner to the radio buttons
        setTimeout(() => {
          const rad = document.querySelectorAll('.cus_li .form-check input')
          for (let i = 0; i < rad.length; i++) {
            rad[i].addEventListener('change', function (event) {
              console.log('Radio button changed from open array page')
              if (!that.chatStarted) {
                if (that.checkAgentEligibility()) {
                  that.getAgentStatus()
                } else {
                  that.eligible = false
                  clearInterval(that.agentAvailabilityInterval)
                }
              }
              // that.checkOpenArrayPageEligibility();
            })
          }
        }, 500)
      }
    },
    setShowChat (value) {
      this.showChatWindow = value
    },
    getCookie (name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
      if (match) return match[2]
    },
    checkAgentEligibility () {
      if (window.location.pathname.includes('order/taqman-files')) {
        if (location.pathname.includes('openarray-plates')) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    getAgentStatusfs () {
      getAgentAvailabilityfs(this.params).then((res) => {
        this.fsAgentAvailableData = res?.data
        this.isChatEnable = res?.data?.agentAvailable
      })
    },
    getAgentStatus () {
      getAgentAvailability(this.params).then((res) => {
        if (res.data?.length > 0) {
          this.eligible = true
          clearInterval(this.agentAvailabilityInterval)
          return
        } else {
          setTimeout(() => {
            clearInterval(this.agentAvailabilityInterval)
            if (!this.eligible) {
              this.agentAvailabilityInterval = setInterval(() => {
                this.getAgentStatus()
              }, 30000)
            }
          }, 500)
          this.eligible = false
        }
        console.log('agent availability response', res)
      }).catch((err) => {
        console.log('agent availability error', err)
      })
    },
    getAgentStatusV2 () {
      if (this.nonIVRAgents.length === 0) {
        this.eligible = false
        clearInterval(this.agentAvailabilityInterval)
        return
      }
      getAgentAvailabilityV2(this.params, this.nonIVRAgents).then((res) => {
        if (res.data?.length > 0) {
          this.eligible = true
          clearInterval(this.agentAvailabilityInterval)
          return
        } else {
          setTimeout(() => {
            clearInterval(this.agentAvailabilityInterval)
            if (!this.eligible) {
              this.agentAvailabilityInterval = setInterval(() => {
                this.getAgentStatusV2()
              }, 30000)
            }
          }, 500)
          this.eligible = false
        }
        console.log('agent availability response', res)
      }).catch((err) => {
        console.log('agent availability error', err)
      })
    }
  }
}

</script>

<style lang="sass">
@import '@/style/theme.sass'
@import '@/style/app.sass'
.main-container
  &.expanded
    top: v-bind('headerHeight')
    max-height: none
</style>
